export default "__VITE_PUBLIC_ASSET__a1137d11__"